import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }
  // Role : 'ADMIN', 'VENDOR','SUPER_ADMIN','USER'
    public profileActions = new BehaviorSubject({loginStatus:false,role:"",profileData:{}});
    public profileActionData = this.profileActions.asObservable();
    public token = "ssssss";
    public refresh_token = "";
    public accessTokenExpiresIn = 0;
  
    setLoggedInStatus(data:any) {
      console.log("LOGGGGG", data)
      this.profileActions.next(data);
  }

   userUuid: string | null = null;

  

  getUserUuid(): string | null {
    return this.userUuid || localStorage.getItem('uuid');
  }
  getProfileData() {
  const data = localStorage.getItem('loginData');
  return data ? JSON.parse(data).profileData : null;
}

}
